import { render, staticRenderFns } from "./RegisterTiles.vue?vue&type=template&id=5a3b3e08&scoped=true&"
import script from "./RegisterTiles.vue?vue&type=script&lang=js&"
export * from "./RegisterTiles.vue?vue&type=script&lang=js&"
import style0 from "./RegisterTiles.vue?vue&type=style&index=0&id=5a3b3e08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3b3e08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VProgressLinear,VRow})
